export default __webpack_public_path__ + "static/media/training-image-01.3a7813c1.jpg";